import script from "./BodySubIntroduction.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubIntroduction.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubIntroduction.vue?vue&type=style&index=0&id=0873b05f&module=introduction&lang=css"
cssModules["introduction"] = style0
import "./BodySubIntroduction.vue?vue&type=style&index=1&id=0873b05f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-0873b05f"]])

export default __exports__
import QVideo from 'quasar/src/components/video/QVideo.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QVideo,QBtn});
